import { EditProjectContextProps } from "../../../EditProjectContext";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { RoutingType } from "../../../../ViewModel/RoutingType";

export const removeSpdrOnThisRouteFromRoutingTable = (
  supplierGsdb: string | undefined,
  plantGsdb: string | undefined,
  dockCode: string | undefined,
  ftlRouteNumber: string | undefined,
  editProjectContext: EditProjectContextProps
) => {
  const { project, setProject } = editProjectContext;
  const route = project.FTLRoutes?.filter(
    (x) => x.RouteNumber === ftlRouteNumber
  )[0] as FtlRouteViewModel;
  if (
    !route ||
    !route.SpdrsOnThisRoute ||
    !route.RoutingTable ||
    !ftlRouteNumber ||
    !supplierGsdb ||
    !plantGsdb ||
    !dockCode
  ) {
    return;
  }
  const spdrsOnThisRoute = route.SpdrsOnThisRoute;

  const spdrOnThisRouteIndex = route.SpdrsOnThisRoute.findIndex(
    (x) =>
      x.SupplierGsdb === supplierGsdb &&
      x.PlantGsdb === plantGsdb &&
      x.DockCode === dockCode
  );

  if (spdrOnThisRouteIndex === -1) {
    return;
  }

  spdrsOnThisRoute.splice(spdrOnThisRouteIndex, 1);

  let returnRoutingTable = route.RoutingTable;
  const isSpdrSupplierOnRoute =
    spdrsOnThisRoute.findIndex((x) => x.SupplierGsdb === supplierGsdb) >= 0;

  const sumSpdrSupplier = returnRoutingTable.filter(
    (x) => x.Gsdb === supplierGsdb && x.RoutingType === RoutingType.Supplier
  ).length;
  if (!isSpdrSupplierOnRoute) {
    returnRoutingTable = returnRoutingTable.filter(
      (x) =>
        !(x.Gsdb === supplierGsdb && x.RoutingType === RoutingType.Supplier)
    );
  }

  const isSpdrPlantDockOnRoute =
    spdrsOnThisRoute.findIndex(
      (x) => x.PlantGsdb === plantGsdb && x.DockCode === dockCode
    ) >= 0;

  if (!isSpdrPlantDockOnRoute) {
    returnRoutingTable = returnRoutingTable.filter(
      (x) => x.DockCode !== dockCode
    );
  }

  const returnReturnFTLRoutes = project.FTLRoutes?.map((routeItem) => {
    if (routeItem.RouteNumber !== ftlRouteNumber) {
      return routeItem;
    }
    return {
      ...routeItem,
      RoutingTable: returnRoutingTable,
    };
  });

  setProject({ ...project, FTLRoutes: returnReturnFTLRoutes });
};
